import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, getHondaCustomerJourney, getHondaNpsBar, GREEN_1, HONDA_SCALE_3_COLORS, msurPorcRespuestasMapper, msurTooltipTotalRegistros, NETPAY_COLORS_STACKED_BAR, RED_1 } from '../commonWidgetsNetpay'
import { getLineDetailedRadar } from '../../widgetsLibrary/widgetsLine'
import { answeredMapper, invalidMapper, isGeoLocationLeaf } from '../../dashHelper'
import { DEFAULT_COLORS_NPS, OXXO_COLORS_CONFIG_SCALE_5 } from '../../oxxoRetails/commonWidgetsOxxoRetail'

const mapLables = {
        1: 'Muy insatisfecho',
        2: 'Insatisfecho',
        3: 'Algo Insatisfecho',
        4: 'Neutral',
        5: 'Algo Satisfecho',
        6: 'Satisfecho',
        7: 'Muy satisfecho'
    };

export default {
    title: 'NetPay - Integracion Técnica Dashboard',
    description: 'Dashboard NetPay - Integracion Técnica',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [
    

          getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'multipleTrendByMonth',
              title: 'NPS',
              size: [2, 2],
              key: 'nps-multiple-trend-by-month',
              indicator: 'np_int_nps_recomienda_netpay',
              mapper: (data, extra) => {
                  return data.map((item: any, idx: any) => ({
                      ...item,
                      groupName: item.groupName + ' (' + item.value + ')',
                  }))
              },
              extraConfigs: {
                  colors: DEFAULT_COLORS_NPS,
                  useCurrent: 0,
                  categories: ['promoters', 'passives', 'detractors'],
                  categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
              }
          }),      
          
          { title: '', size: [2, 2], type: 'empty-space', },
          

          getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'gaugeGeneric',
              title: 'Satisfacción con el proceso de integración en general',
              size: [1, 2],
              indicator: 'np_int_csat',
              //helpText: '<p><b>Pregunta: </b><br/><br/>Pensando en tu visita de hoy, ¿Qué tan satisfecho(a) estás con tu experiencia?.</p>',


              extraConfigs: {
                  decimals: 1,
                  maxValue: 7,
                  showPercentage: false,
                  colors: OXXO_COLORS_CONFIG_SCALE_5,
              },
              historic: {
                type: 'line',
                formula: 'wavg',
            }
          }),
          
          getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'stackedBar',
              title: " ¿Qué tan fácil fue integrar NetPay a tu sistema?",
              //subTitle: ind.subTitle,
              size: [3, 1],
              //helpText: ind.helpText,
              indicator: "np_int_csat_integrar_sistema",
              mapper: (data: any) => {
                  return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                      ...item,
                  }))
              },
              extraConfigs: {
                  colors: NETPAY_COLORS_STACKED_BAR,
                  groupLabels: mapLables,
                  showLegend: true,
              }
          }),

          getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'stackedBar',
              title: "¿La documentación proporcionada fue clara y útil?",
              //subTitle: ind.subTitle,
              size: [3, 1],
              //helpText: ind.helpText,
              indicator: "np_int_csat_documentacion",
              mapper: (data: any) => {
                  return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                      ...item,
                  }))
              },
              extraConfigs: {
                  colors: NETPAY_COLORS_STACKED_BAR,
                  groupLabels: mapLables,
                  showLegend: true,
              }
          }),
          { title: '', size: [1, 1], type: 'empty-space', },

          getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'stackedBar',
              title: "¿El equipo de NetPay te brindó apoyo durante la integración?",
              //subTitle: ind.subTitle,
              size: [3, 1],
              //helpText: ind.helpText,
              indicator: "np_int_csat_soporte",
              mapper: (data: any) => {
                  return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                      ...item,
                  }))
              },
              extraConfigs: {
                  colors: NETPAY_COLORS_STACKED_BAR,
                  groupLabels: mapLables,
                  showLegend: true,
              }
          }),

          








        ]
    },
} as DasboardConfig
